import { FM } from '../js/config.js';
import { initHTML } from '../js/init-bootstrap-html.js';
import { getLocale } from '../js/locale.js';

import './core-js-legacy.js';
import 'systemjs/dist/s.js';

import { entries as manifestDesktop } from '/dist/app/nomodule/desktop/manifest.json';

/*global top, self, window, document, location, System */
if (top !== self) {
    // Frame buster.
    top.location.replace(location);
} else if (!Array.from) {
    // This browser is too old; doesn't support features we need
    const errorText = document.getElementById('loading-error');
    errorText.style.display = 'block';
} else if (!PRODUCTION || (location.protocol === 'https:' && window.URL)) {
    // OK JMAP UI is supported we're on HTTPS, and we're not already loaded so…
    const manifest = manifestDesktop;
    const pathToModules =
        FM.pathToDist + `/app/nomodule/desktop/`;

    FM.manifest = manifest;
    FM.preload = function () {};
    FM.import = function (thunk) {
        return thunk();
    };

    window.FastMail = FM; // For the app
    window.FM = FM;

    initHTML();

    System.import(pathToModules + getLocale(manifest, FM.sessions, FM.userId));
}
